import React from "react"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"

import ThemeLayoutLeftContentBackdropForm from "./ThemeLayoutLeftContentBackdropForm"
import ThemeLayoutLeftContentShowcaseForm from "./ThemeLayoutLeftContentShowcaseForm"

export interface ThemeLayoutLeftContentTabPanelProps {
  variant: ThemeLayoutEnum
}

const ThemeLayoutLeftContentTabPanel = ({ variant }: ThemeLayoutLeftContentTabPanelProps) => {
  if (variant === ThemeLayoutEnum.SHOWCASE) {
    return <ThemeLayoutLeftContentShowcaseForm />
  }

  return <ThemeLayoutLeftContentBackdropForm />
}

export default ThemeLayoutLeftContentTabPanel
